import React, { useEffect, useRef, useState } from "react";
import { Card, Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import { Link, useNavigate } from "react-router-dom";
import "./request-withdrawal.scss";
import {
  addCommas,
  deductFromFlexiAccess,
  extractDrawdownStrategies,
  hasContextPath,
  openPopup,
} from "../../helpers/helpers";
import ReactCardFlip from "react-card-flip";
import Buttons from "../../atoms/Buttons";
import { ModalOverlay } from "../../atoms/Modal";
import { WITHDRAW_CATEGORY } from "../../constants/constants";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";

const RequestWithdrawal = (props) => {
  const { investorId } = props.memberObj;
  const [isFlipped, setIsFlipped] = useState({});
  const [withdrawalSummaryModalShow, setWithdrawalSummaryModalShow] =
    useState(false);
  const [
    withdrawalRequestReceivedModalShow,
    setWithdrawalRequestReceivedModalShow,
  ] = useState(false);
  const [aboutFlexiAccessWithdrawal, setAboutFlexiAccessWithdrawal] =
    useState(false);
  const [yourbanktransfer, setYourbanktransfer] = useState(false);
  const popupShown = useRef(false);
  const navigate = useNavigate();
  const errorShown = useRef(false);

  const { data: prodOverData } = useSelector(
    (state) => state.futureCalculatorHome, // eslint-disable-line
  );

  const { lumpSumsFetching, lumpSumsData, lumpSumsError } = useSelector(
    (state) => state.lumpSumsWithdrawal, // eslint-disable-line
  );

  const { illustrationFetching, illustrationData, illustrationError } =
    useSelector(
      (state) => state.viewIllustration // eslint-disable-line
    );

  const dispatch = useDispatch();
  const {
    FutureCalculatorHomeContent,
    lumpSumsWithdrawal,
    getIllustrationContent,
  } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  useEffect(() => {
    if (investorId) {
      FutureCalculatorHomeContent(investorId);
    }
  }, []);

  useEffect(() => {
    if (
      lumpSumsFetching === false &&
      lumpSumsData.isSuccess === true &&
      popupShown.current === true
    ) {
      setWithdrawalSummaryModalShow(false);
      setWithdrawalRequestReceivedModalShow(true);
      errorShown.current = false;
    } else if (popupShown.current === true) {
      errorShown.current = true;
    }
  }, [lumpSumsFetching, lumpSumsData, lumpSumsError]);

  useEffect(() => {
    if (illustrationFetching === false && illustrationData?.length !== 0) {
      const blob = new Blob([illustrationData], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    }
  }, [illustrationFetching, illustrationData, illustrationError]);

  // prettier-ignore
  const [initialStrategies] = useState(
    extractDrawdownStrategies(props.selectedPot).map((strategy) => ({
      ...strategy,
      incomePercentage: (
        (strategy.currentIncome / strategy.currentValue) *
        100
      ).toFixed(2),
    }))
  );

  // prettier-ignore
  const [strategies, setStrategies] = useState(
    extractDrawdownStrategies(props.selectedPot).map((strategy) => ({
        ...strategy,
        incomePercentage: (
          (strategy.currentIncome / strategy.currentValue) *
          100
        ).toFixed(2),
        withdrawAmount: 0,
        newValue: strategy.currentValue,
        newIncome: strategy.currentIncome
      }))
);

  const [finalResult, setFinalResult] = useState([]);

  // prettier-ignore
  useEffect(() => {
    setStrategies([
      ...extractDrawdownStrategies(props.selectedPot).map((strategy) => ({
        ...strategy,
        incomePercentage: (
          (strategy.currentIncome / strategy.currentValue) *
          100
        ).toFixed(2),
        withdrawAmount: 0,
        newValue: strategy.currentValue,
        newIncome: strategy.currentIncome
      })),
    ]);
  }, []);
  //

  const handleBack = (e) => {
    e.preventDefault();
    navigate("/manage?tab=withdrawals");
  };
  const handleCancel = () => {
    navigate("/manage?tab=withdrawals");
  };
  const handleClick = (cardId) => {
    setIsFlipped((prevState) => ({
      ...prevState,
      [cardId]: !prevState[cardId],
    }));
  };

  // prettier-ignore
  const handleInputChange = (cardId, value) => {
    let val = value?.trimStart().replace(/\s+/g, "") || "0";

    if (val !== "0") {
      val = val.replace(/^0+(?!\.)/, "");
    }

    // Regular expression to match numbers with up to two decimal places
    const regex = /^\d*\.?\d{0,2}$/;

    // Check if the value matches the regex
    if (!regex.test(val)) {
      return; // If not, do nothing
    }

    let newValue = val === "" ? 0 : parseFloat(val);

    // Find the current value for the given cardId
    const currentStrategy = initialStrategies.find(
      (obj) => obj.strategyId === cardId
    );
    if (newValue > currentStrategy.currentValue) {
      return; // If the new value exceeds the current value, do nothing
    }

    setStrategies((prevStrategies) => {
      return prevStrategies.map((strategy) => {
        if (strategy.strategyId === cardId) {
          return {
            ...strategy,
            withdrawAmount: val,
            newValue: (
              initialStrategies.find((obj) => obj.strategyId === cardId)
                .currentValue - newValue
            ).toFixed(2),
            newIncome:
              strategy.strategyName !== "Flexi-access"
                ? (initialStrategies.find((obj) => obj.strategyId === cardId)
                    .currentValue -
                    newValue) /
                  (initialStrategies.find((obj) => obj.strategyId === cardId)
                    .currentValue /
                    initialStrategies.find((obj) => obj.strategyId === cardId)
                      .currentIncome)
                : strategy.currentIncome,
          };
        }
        return strategy;
      });
    });
  };

  const handleContinue = () => {
    if (
      strategies.find((strategy) => strategy.strategyName === "Flexi-access")
        .withdrawAmount > 0
    ) {
      setYourbanktransfer(false);
      setAboutFlexiAccessWithdrawal(true);
    } else {
      setAboutFlexiAccessWithdrawal(false);
      setYourbanktransfer(true);
    }
  };
  const handleWithdrawalSummaryContinue = () => {
    popupShown.current = true;
    const payload = {
      investments: [],
      totalAmount: parseFloat(
        strategies.reduce(
          (acc, strategy) =>
            acc +
            parseFloat(
              strategy.withdrawAmount === "" ? 0 : strategy.withdrawAmount, // eslint-disable-line
            ),
          0, // eslint-disable-line
        ), // eslint-disable-line
      ),
    };
    const finalRequest = finalResult?.filter(
      (item) => item.withdrawAmount > 0 && item.withdrawAmount !== "", // eslint-disable-line
    );
    const finalInvestmentRequest = finalResult
      ?.filter((item) => item.strategyName === "Flexi-access")
      .flatMap((item) => item.investments)
      .filter(
        (investment) =>
          investment.withdrawAmount > 0 && investment.withdrawAmount !== "", // eslint-disable-line
      );
    finalInvestmentRequest.forEach((investment) => {
      finalRequest.push(investment);
    });

    finalRequest.forEach((item) => {
      if (
        item.withdrawAmount &&
        parseFloat(item.withdrawAmount) > 0 &&
        item.strategyName !== "Flexi-access"
      ) {
        payload.investments.push({
          investmentId: parseInt(item.strategyId || item.investmentId),
          amount: String(parseFloat(item.withdrawAmount).toFixed(2)),
          cashReservePurpose: "IddPayments",
        });
      }
    });
    lumpSumsWithdrawal(payload, investorId, props.selectedPot?.membershipId);
  };

  const handleAboutFlexiAccessWithdrawal = () => {
    setAboutFlexiAccessWithdrawal(false);
    setYourbanktransfer(true);
  };

  const handleIllustration = () => {
    const findFlexiAccess = strategies.find(
      (strategy) => strategy.strategyName === "Flexi-access",
    );

    let frequency = "";

    if (findFlexiAccess?.duration === "Monthly") {
      frequency = 1;
    } else if (findFlexiAccess?.duration === "Quarterly") {
      frequency = 3;
    } else if (findFlexiAccess?.duration === "HalfYearly") {
      frequency = 6;
    } else if (findFlexiAccess?.duration === "Annual") {
      frequency = 12;
    }

    const payload = {
      investorId: investorId,
      investorAccountId: props.selectedPot?.membershipId,
      incomeFrequency: frequency,
      targetTfcPercentage: "0",
      incomeAmount: findFlexiAccess?.currentIncome,
    };
    getIllustrationContent(payload);
  };

  const handleYourBankTransfer = () => {
    setFinalResult(deductFromFlexiAccess(strategies));
    setYourbanktransfer(false);
    setWithdrawalSummaryModalShow(true);
  };

  const tooltip = (
    <Popover id="eac-pop-id" className="withdraw-popover-inner">
      <Popover.Body className="withdraw-popover-body">
        <div>Total before</div>
        <div>income tax</div>
      </Popover.Body>
    </Popover>
  );

  const riskRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="adhoc-popover-inner">
        <Popover.Body className="adhoc-popover-body">
          <div className="sub-title mb-2">
            It measures the relative risk and reward of an investment fund,
            where 1 being low risk and potentially low returns up to 7 high risk
            and potentially high returns.
          </div>
          <div className="sub-title mb-3">
            It’s calculated using past performance and volatility. This risk
            rating is a ‘Synthetic Risk and Reward Indicator’ (SRRI). The SRRI
            risk ratings are based on European Security and Markets Authority
            (ESMA) guidelines.
          </div>
          <div className="sub-title mb-3">
            The risk rating doesn’t guarantee how the fund will perform in the
            future, and it can change over time.
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const esgRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="adhoc-popover-inner">
        <Popover.Body className="adhoc-popover-body">
          <div className="sub-title mb-2">
            The MSCI ESG Fund Rating is designed to measure the Environmental,
            Social and Governance (ESG) characteristics of a fund’s underlying
            investment holdings.
          </div>
          <div className="sub-title mb-3">
            The ESG Rating ranges from leader (AAA, AA), average (A, BBB, BB) to
            laggard (B, CCC).
          </div>
          <div className="sub-title mb-3">
            The overall fund score is based on each individual holding’s ESG
            rating and the proportion held in this fund (and if there is
            sufficient available data to do so).
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <div>
      <div className="req-withdrawal-back-button mb-2 mt-3">
        <Link className="req-withdrawal-back-link" to="#" onClick={handleBack}>
          <Icons iconname="chevron-left" variant="icon-sixteen-px" />
          Back
        </Link>
      </div>
      <Card>
        <div className="parent-withdrawal">
          <Row>
            <Col lg={7} sm={12} xs={12}>
              <p className="rw-heding-text">
                {
                  "Input the amount that you wish to withdraw from your drawdown pot(s). Taking money from Managed income or Future annuity income will also alter your future income. The amount withdrawn will be subject to income tax before it is paid to you."
                }
              </p>
            </Col>
            <Col lg={5}>
              <p className="mb-1 text-center total-withdraw-text">
                {"Total withdrawing"}{" "}
                <OverlayTrigger
                  placement="bottom"
                  overlay={tooltip}
                  flip={true}
                >
                  <span>
                    <Icons iconname="tool-tip" variant="icon-sixteen-px" />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="text-center total-withdraw-amount">
                £
                {addCommas(
                  Math.trunc(
                    strategies.reduce(
                      (acc, strategy) =>
                        acc +
                        parseFloat(
                          strategy.withdrawAmount === ""
                            ? 0
                            : strategy.withdrawAmount, // eslint-disable-line
                        ),
                      0, // eslint-disable-line
                    ), // eslint-disable-line
                  ), // eslint-disable-line
                )}
                .
                <span className="subset-small">
                  {(
                    strategies.reduce(
                      (acc, strategy) =>
                        acc +
                        parseFloat(
                          strategy.withdrawAmount === ""
                            ? 0
                            : strategy.withdrawAmount, // eslint-disable-line
                        ),
                      0, // eslint-disable-line
                    ) % 1
                  )
                    .toFixed(2)
                    .substring(2)}
                </span>
              </p>
            </Col>
          </Row>
          {strategies &&
            strategies?.map(
              (item) =>
                parseFloat(item?.currentValue) !== 0 ? (
                  <ReactCardFlip
                    key={item?.strategyId}
                    isFlipped={isFlipped[item?.strategyId] || false}
                    flipDirection="horizontal"
                  >
                    <div
                      className="front-withdrawal-card"
                      key={`front-${item?.strategyId}`}
                    >
                      <div className="card-front">
                        <p className="mt-3 fund-category">
                          {" "}
                          {item?.category === WITHDRAW_CATEGORY.FOR_INCOME
                            ? "INCOME"
                            : item?.category === WITHDRAW_CATEGORY.SELF_MANAGED
                              ? "SELF MANAGED"
                              : "GROWTH"}
                        </p>
                        <p className="fund-strategyName">
                          {" "}
                          {["safety", "safety net", "safety net fund"].includes(
                            (item?.strategyName || "").toLowerCase().trim(),
                          )
                            ? "Safety net"
                            : ["legacy", "legacy fund"].includes(
                                  (item?.strategyName || "")
                                    .toLowerCase()
                                    .trim(),
                                )
                              ? "Legacy"
                              : item?.strategyName}
                        </p>
                        <p className="mt-5 fund-strategy-desc">
                          {" "}
                          {item?.category === WITHDRAW_CATEGORY.FOR_INCOME
                            ? item?.shortDesc
                            : item?.category === WITHDRAW_CATEGORY.SELF_MANAGED
                              ? "A fully flexible option where you decide the funds you’d like to invest, when you take out money and how much."
                              : item?.shortDesc}
                        </p>
                        <div className="mt-4 d-flex justify-content-between">
                          <span className="current-value-text">
                            Current value
                          </span>
                          <span className="current-value">
                            £{addCommas(Math.trunc(item?.currentValue))}.
                            <span>
                              {(item?.currentValue % 1).toFixed(2).substring(2)}
                            </span>
                          </span>
                        </div>
                        {item?.currentIncome !== undefined &&
                        item?.category !== WITHDRAW_CATEGORY.GROWTH ? (
                          <div className="mt-2 d-flex justify-content-between">
                            <span className="current-value-text">
                              Current income
                            </span>
                            <span className="current-value">
                              £{addCommas(Math.trunc(item?.currentIncome))}.
                              <span>
                                {(item?.currentIncome % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                              <span className="current-value-pm">
                                {item.duration?.toLowerCase() ===
                                "Monthly".toLowerCase()
                                  ? "p/m"
                                  : item.duration?.toLowerCase() ===
                                      "Quarterly".toLowerCase()
                                    ? "p/q"
                                    : item.duration?.toLowerCase() ===
                                        "HalfYearly".toLowerCase()
                                      ? "p/6m"
                                      : item.duration?.toLowerCase() ===
                                          "Annual".toLowerCase()
                                        ? "p/y"
                                        : ""}
                              </span>
                            </span>
                          </div>
                        ) : (
                          <div className="mt-5"></div>
                        )}
                        <hr className="w-lower-line" />
                        <p className="current-value-text mb-0">
                          Enter withdrawal amount
                        </p>
                        <div className="current-value-sub-text mb-0">
                          You can estimate your post-tax amount{" "}
                          <Link
                            to="https://www.gov.uk/estimate-income-tax"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Buttons className="tertiary-small" name="here" />
                            <span className="icon">
                              <Icons
                                iconname="external-link"
                                variant="icon-twelve-px ms-1"
                              />
                            </span>
                          </Link>
                        </div>
                        <input
                          type="text"
                          className="input-text"
                          value={`£${addCommas(item.withdrawAmount)}`}
                          onChange={(e) => {
                            handleInputChange(
                              item?.strategyId,
                              e.target.value
                                .replace("£", "")
                                .replaceAll(",", ""),
                            );
                          }}
                        />
                        <div className="d-flex justify-content-between">
                          <span className="current-value-text">New value</span>
                          <span className="current-value">
                            £
                            {addCommas(
                              parseFloat(item.withdrawAmount) !== 0 &&
                                item.withdrawAmount !== "" &&
                                item.withdrawAmount !== undefined
                                ? parseFloat(item.newValue).toFixed(2)
                                : "0.00",
                            )}
                          </span>
                        </div>
                        {item?.currentIncome !== undefined &&
                        item?.category !== WITHDRAW_CATEGORY.GROWTH ? (
                          <div className="mt-2 d-flex justify-content-between">
                            <span className="current-value-text">
                              New income
                            </span>
                            <span className="current-value">
                              £
                              {addCommas(
                                parseFloat(item.withdrawAmount) !== 0 &&
                                  item.withdrawAmount !== "" &&
                                  item.withdrawAmount !== undefined
                                  ? parseFloat(item.newIncome).toFixed(2)
                                  : "0.00",
                              )}
                              <span className="current-value-pm">
                                {item.duration?.toLowerCase() ===
                                "Monthly".toLowerCase()
                                  ? "p/m"
                                  : item.duration?.toLowerCase() ===
                                      "Quarterly".toLowerCase()
                                    ? "p/q"
                                    : item.duration?.toLowerCase() ===
                                        "HalfYearly".toLowerCase()
                                      ? "p/6m"
                                      : item.duration?.toLowerCase() ===
                                          "Annual".toLowerCase()
                                        ? "p/y"
                                        : ""}
                              </span>
                            </span>
                          </div>
                        ) : (
                          <div className="mt-4"></div>
                        )}
                        {item?.category === WITHDRAW_CATEGORY.SELF_MANAGED ? (
                          <div className="button-align-self-managed">
                            <Buttons
                              name="Product overview"
                              className="secondary"
                              handleClick={() => {
                                let split =
                                  prodOverData?.properties?.productOverview[0]?.route?.path?.split(
                                    "/", // eslint-disable-line
                                  );
                                let splicedStr = split
                                  .slice(0, split.length - 2)
                                  .join("/");
                                window.open(
                                  hasContextPath() +
                                    `/product-overview/?${splicedStr
                                      .split("/")
                                      .slice(2)
                                      .join("/")}`,
                                  "_blank", // eslint-disable-line
                                );
                              }}
                            ></Buttons>
                          </div>
                        ) : (
                          <div className="button-align">
                            <Buttons
                              name="View full fund fact sheet"
                              className="tertiary mt-3"
                              handleClick={() => openPopup(item?.mediaUrl)}
                            ></Buttons>
                            <Buttons
                              name="See overview"
                              className="secondary mt-1"
                              handleClick={() => handleClick(item?.strategyId)}
                            ></Buttons>
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      className="back-withdrawal-card"
                      key={`back-${item.strategyId}`}
                    >
                      <div className="card-back">
                        <p className="mt-3 fund-category">
                          {" "}
                          {item?.category === WITHDRAW_CATEGORY.FOR_INCOME
                            ? "INCOME"
                            : item?.category === WITHDRAW_CATEGORY.SELF_MANAGED
                              ? "SELF MANAGED"
                              : "GROWTH"}
                        </p>
                        <p className="fund-strategyName">
                          {" "}
                          {["safety", "safety net", "safety net fund"].includes(
                            (item?.strategyName || "").toLowerCase().trim(),
                          )
                            ? "Safety net"
                            : ["legacy", "legacy fund"].includes(
                                  (item?.strategyName || "")
                                    .toLowerCase()
                                    .trim(),
                                )
                              ? "Legacy"
                              : item?.strategyName}
                        </p>
                        <div>
                          <Row className="managed-by-text">
                            <Col>
                              <div className="managed-parent-text">
                                <span className="left-text">Managed by</span>
                                <span className="right-text">
                                  {item.managedBy}
                                </span>
                              </div>
                            </Col>
                          </Row>
                          <Row className="managed-by-text">
                            <Col>
                              <div className="managed-parent-text">
                                <span className="left-text">Fund charge</span>
                                <span className="right-text">
                                  {item.fundCharge}
                                </span>
                              </div>
                            </Col>
                          </Row>
                          <Row className="managed-by-text">
                            <Col>
                              <div className="managed-parent-text">
                                <span className="left-text">
                                  Risk rating
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={riskRatingToolTip(item.strategyId)}
                                    flip={true}
                                  >
                                    <span className="risk-rating-icon-margin">
                                      <Icons
                                        iconname="tool-tip"
                                        variant="icon-sixteen-px"
                                      />
                                    </span>
                                  </OverlayTrigger>
                                </span>
                                <span className="right-text">
                                  {item.riskRating}
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="Average-text">
                          Average ESG Rating{" "}
                          <span
                            className="risk-rating-icon-margin"
                            id={item.strategyId}
                          >
                            <OverlayTrigger
                              id={item.strategyId}
                              placement="bottom"
                              overlay={esgRatingToolTip(item.strategyId)}
                              flip={true}
                            >
                              <span>
                                <Icons
                                  iconname="tool-tip"
                                  variant="icon-sixteen-px"
                                />
                              </span>
                            </OverlayTrigger>
                          </span>
                        </div>
                        <div className="parent-rating-box">
                          <span
                            className={
                              item.ESGRating === "CCC"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            CCC
                          </span>
                          <span
                            className={
                              item.ESGRating === "B"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            B
                          </span>
                          <span
                            className={
                              item.ESGRating === "BB"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            BB
                          </span>
                          <span
                            className={
                              item.ESGRating === "BBB"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            BBB
                          </span>
                          <span
                            className={
                              item.ESGRating === "A"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            A
                          </span>
                          <span
                            className={
                              item.ESGRating === "AA"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            AA
                          </span>
                          <span
                            className={
                              item.ESGRating === "AAA"
                                ? "colored-rating-box"
                                : "rating-box"
                            }
                          >
                            AAA
                          </span>
                        </div>
                        <div className="button-align">
                          <div className="view-fund-button">
                            <Buttons
                              name="View full fund fact sheet"
                              className="tertiary"
                              handleClick={() => openPopup(item?.mediaUrl)}
                            ></Buttons>
                          </div>
                          <Buttons
                            name="Close overview"
                            className="secondary"
                            handleClick={() => handleClick(item.strategyId)}
                          ></Buttons>
                        </div>
                      </div>
                    </div>
                  </ReactCardFlip>
                ) : (
                  ""
                ), //eslint-disable-line
            )}
        </div>
      </Card>
      <Row className="mt-3 req-withdrawal-footer">
        <div className="d-flex justify-content-between">
          <Buttons
            name="Cancel"
            className="secondary"
            variantname="icon-sixteen-px"
            handleClick={handleCancel}
          ></Buttons>
          <Buttons
            name="Continue"
            className="primary"
            variantname="icon-sixteen-px"
            handleClick={handleContinue}
            disabled={
              strategies.reduce(
                (acc, strategy) =>
                  acc +
                  parseFloat(
                    strategy.withdrawAmount === ""
                      ? 0
                      : strategy.withdrawAmount, // eslint-disable-line
                  ),
                0, // eslint-disable-line
              ) === 0 // eslint-disable-line
            }
          ></Buttons>
        </div>
      </Row>
      <ModalOverlay
        popup="AboutFlexiAccessWithdrawal"
        show={aboutFlexiAccessWithdrawal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setAboutFlexiAccessWithdrawal(false);
        }}
        modaltitle="About your flexi-access withdrawal"
        handleContinue={handleAboutFlexiAccessWithdrawal}
        handleIllustration={handleIllustration}
        strategies={strategies}
      />
      <ModalOverlay
        popup="yourbanktransfer"
        show={yourbanktransfer}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setYourbanktransfer(false);
        }}
        modaltitle="Your bank transfer"
        handleContinue={handleYourBankTransfer}
      />
      <ModalOverlay
        popup="WithdrawalSummary"
        show={withdrawalSummaryModalShow}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setWithdrawalSummaryModalShow(false);
        }}
        modaltitle="Withdrawal summary"
        handleContinue={handleWithdrawalSummaryContinue}
        strategies={finalResult}
        initialStrategies={initialStrategies}
        lumpSumsFetching={lumpSumsFetching}
        lumpSumsError={lumpSumsError}
        errorShown={errorShown.current}
      />
      {/* Withdrawal request received Modal */}
      <ModalOverlay
        popup="WithdrawalRequestReceived"
        show={withdrawalRequestReceivedModalShow}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setWithdrawalRequestReceivedModalShow(false);
        }}
        modaltitle="Withdrawal request received"
      />
    </div>
  );
};

export default RequestWithdrawal;
